import { Text, TextProps, Link } from "@chakra-ui/layout";
import * as React from "react";
import { Link as ReachLink } from "react-router-dom";

export const Copyright = (props: TextProps) => (
  <Text fontSize="sm" {...props}>
    &copy; {new Date().getFullYear()}{" "}
    <Link
      as={ReachLink}
      to="/"
      _hover={{
        textDecoration: "none",
        color: "lightblue",
      }}
      _focus={{
        outline: "none",
        boxShadow: "none",
        textDecor: "none",
      }}
    >
      GoodRegime
    </Link>
    , All rights reserved.
  </Text>
);
